// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2H7wZ","emails":"CreateEditClinics_emails__1Gklw","emailTagLabel":"CreateEditClinics_emailTagLabel__Cp74f"};